import React, {useState, useRef, useContext} from 'react';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {MDBCheckbox} from 'mdb-react-ui-kit';
import {Card, ListGroup} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrash, faPencilAlt} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router';
import {useParams} from 'react-router-dom';
import { updatePhotoExtra } from '../../../../services/MadricService';
import { MadricContext } from '../../../../Context/MadricContext';

/**
 *  L'accueil
 * @param {*} props props
 * @return {JSX}
 */
function Photo(props) {

  const {id} = useParams();

  let photo = props.photo;
  let returnTo = 'historique'
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const {projectInfo, setProjectInfo, setScrollPosition} = useContext(MadricContext);
  const navigate = useNavigate();

  const extra = useRef({
    extra1: props.photo.extra1,
    extra2: props.photo.extra2,
    extra3: props.photo.extra3,
    avancement: props.photo.avancement,
  });

  const handlePhotoClick = (photo) => {
    document.body.classList.add('modal-open');
    setSelectedPhoto(photo);
  };

  const handleCloseModal = () => {
    document.body.classList.remove('modal-open');
    setSelectedPhoto(null);
  };

  const handleZoom = (event) => {
    const img = event.target;
    const currentScale = parseFloat(img.style.transform.replace('scale(', '').replace(')', '') || 1);
    const delta = event.deltaY > 0 ? -0.1 : 0.1;
    const newScale = Math.max(currentScale + delta, 0.1);
    img.style.transform = `scale(${newScale})`;
  };

  const handleModalScroll = (event) => {
    event.preventDefault();
  };

    /**
 * Permet de modifier les extras
 * @param {*} event event
 */
    async function handleChangeExtra(event) {
      extra.current = {
        ...extra.current,
        [event.target.name]: event.target.checked,
      };
  
  
      const updatedPhoto = projectInfo.map((p) => {
        if (p.id === props.photo.id && (p.type === 'photo' || p.type === 'facture')) {
          return {
            ...p,
            extra1: extra.current.extra1,
            extra2: extra.current.extra2,
            extra3: extra.current.extra3,
            avancement: extra.current.avancement,
  
          };
        }
        return p;
      });
      setProjectInfo(updatedPhoto);
      await updatePhotoExtra(props.photo.id, extra.current);
    }

  return (
    <div className="checkin-container">
      <Card className="checkin-card">
        <Card.Header className="checkin-header">
          <span style={{fontWeight: 'bold', textDecoration: 'underline'}}>{props.photo.type ==='photo' ? 'PHOTO' : 'FACTURE'}</span> {props.formatDate(props.photo.date)}
          <button className="checkin-pagination-button float-end" onClick={() => {setScrollPosition({x: window.scrollX, y: window.scrollY}); navigate('/UpdatePhoto', {state: {photo, id, returnTo}})}}><FontAwesomeIcon icon={faPencilAlt} /></button>
        </Card.Header>

        <ListGroup variant="flush">
          <ListGroup.Item className="checkin-list-item" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <LazyLoadImage
              src={props.photo.url}
              alt={props.photo.title}
              className="chantierheure-photo"
              placeholderSrc="/images/notloaded.png"
              onClick={() => handlePhotoClick(props.photo)}
              effect="blur" />
          </ListGroup.Item>


          <ListGroup.Item className="checkin-list-item">
          Employé: {props.photo.user_name}
          </ListGroup.Item>
          {props.photo.type === 'facture' ?
        <ListGroup.Item className="checkin-list-item ">
          Facture: {props.photo.facturename}
        </ListGroup.Item> : ''}
          {props.photo.type === 'facture' ?
        <ListGroup.Item className="checkin-list-item ">
          Montant: {props.photo.montant} $
        </ListGroup.Item> : ''}


          <ListGroup.Item>
            <MDBCheckbox
              name="extra1"
              id="inlineCheckbox111"
              defaultChecked={props.photo.extra1}
              label="Extra possible"
              onChange={handleChangeExtra}
              inline
            />
            {localStorage.getItem('admin') === '1' ? (
            <React.Fragment>
              <MDBCheckbox
                name="extra2"
                id="inlineCheckbox222"
                defaultChecked={props.photo.extra2}
                label="Extra valider"
                onChange={handleChangeExtra}
                inline
              />
              <MDBCheckbox 
                name="extra3"
                id="inlineCheckbox333"
                defaultChecked={props.photo.extra3}
                label="Extra confirmer"
                onChange={handleChangeExtra}
                inline
              />
              <MDBCheckbox
                name="avancement"
                id="inlineCheckbox333"
                defaultChecked={props.photo.avancement}
                label="Avancement"
                onChange={handleChangeExtra}
                inline
              />
            </React.Fragment>
          ) : (
            ' '
          )}
          </ListGroup.Item>
          <ListGroup.Item className="checkin-list-item ">
          Note: {props.photo.note}
          </ListGroup.Item>
        </ListGroup>
      </Card>
      {selectedPhoto && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <img
            src={selectedPhoto.url}
            alt={selectedPhoto.title}
            className="modal-photo"
            onWheel={handleZoom}
            onTouchMove={handleModalScroll} />
        </div>)}
    </div>
  );
}

export default Photo;
